import { UseQueryResult } from '@tanstack/react-query'
import { useCachedQuery } from 'sierra-client/state/api'
import { Organization } from 'sierra-domain/organization'
import { XRealtimeUserGetOrganization } from 'sierra-domain/routes'

export function useOrganizationConfig(): UseQueryResult<Organization> {
  return useCachedQuery(XRealtimeUserGetOrganization, {})
}
